import InsurancePageTemplate from "@/components/InsurancePageTemplate";

export const config = {
  providerName: "Blue Cross of Idaho",
  shortName: "BC Idaho",
  slug: "bc-idaho-insurance",
  seoTitle: "Blue Cross of Idaho TMS & SPRAVATO® Coverage | Neuro Wellness TMS",
  seoDescription:
    "Learn how Blue Cross of Idaho policies cover TMS Therapy, SPRAVATO® esketamine, and advanced depression care at Neuro Wellness TMS in Coral Springs, FL.",
  seoKeywords:
    "Blue Cross Idaho TMS coverage, BC Idaho SPRAVATO authorization, Blue Cross Idaho mental health benefits Coral Springs FL, Blue Cross Idaho depression treatment Florida",
};

export const BcIdahoInsurance = () => <InsurancePageTemplate config={config} />;
export default BcIdahoInsurance;
